import { Link } from 'react-router-dom'
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { TasksStatuses, TasksPriorities } from '../../constants'
import { ResidualRisksRates } from 'src/common/constants'

const formatRiskId = ({
    organization,
    secondary_id,
    is_general
}) => {
    if (is_general) {
        return `R${secondary_id}`
    }

    if (organization) {
        if (organization.is_own_company) {
            return `E${organization.secondary_id}/R${secondary_id}`
        }
        else {
            return `TP${organization.secondary_id}/R${secondary_id}`
        }
    }

    return ''
}

export const tableAllRisksColumnsRenderer = ({
    t,
    dateUtils,
    onDeleteButtonClicked,
    history
}) => {
    return [
        {
            dataField: 'result_color',
            text: t('Rating'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '80px'
            },
            key: 1,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span
                            className='dt-risk-rating-bullet'
                            style={{
                                backgroundColor: `#${cellContent}`,
                                opacity: row.is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'id',
            text: t('Risk ID'),
            sort: false,
            key: 2,
            style: {
                width: '80px'
            },
            formatter: (cellContent, row) => {
                return (
                    <span
                        style={{
                            cursor: !row.is_deleted && 'pointer'
                        }}
                        className={!row.is_deleted ? 'btn-link' : ''}
                        onClick={() =>
                            !row.is_deleted &&
                            history.push(
                                `/admin/risk-management/${row.id}/details?incomming_tab=all-risks`
                            )
                        }
                    >
                        {formatRiskId(row)}
                    </span>
                )
            }
        },
        {
            dataField: 'title',
            text: t('Risk Title'),
            sort: false,
            key: 3,
            style: {
                width: '140px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.acceptance?.accepted && (
                            <div>
                                <span
                                    className='badge bg-success text-white rounded'
                                    style={{ cursor: "pointer" }}
                                    id={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('Accepted')}
                                </span>

                                <UncontrolledTooltip
                                    placement="top"
                                    target={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('This risk has been accepted.')}<br />
                                    {t('Justification')}: {row.acceptance?.reason}
                                </UncontrolledTooltip>
                            </div>
                        )}
                        <span
                            style={{
                                cursor: !row.is_deleted && 'pointer'
                            }}
                            onClick={() =>
                                !row.is_deleted &&
                                history.push(
                                    `/admin/risk-management/${row.id}/details?incomming_tab=all-risks`
                                )
                            }
                            className={!row.is_deleted ? 'btn-link' : ''}
                        >{cellContent}</span>
                    </div>
                )
            }
        },
        {
            dataField: 'case_id',
            text: t('Entity'),
            headerStyle: {
                textAlign: 'center'
            },
            sort: false,
            key: 4,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div className='text-center'>
                        {row.organization.name}
                    </div>
                )
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 5,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row.category.main.name)}</div>
            }
        },
        {
            dataField: 'category',
            text: t('Sub Category'),
            sort: false,
            key: 6,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row.category.subCategory.name)}</div>
            }
        },
        {
            dataField: "residual_risk",
            text: t("Residual Risk Rate"),
            sort: false,
            key: 7,
            style: {
                width: '120px'
            },
            formatter: (cellContent, {
                is_deleted
            }) => {
                return (
                    <div>
                        <span title={t(ResidualRisksRates[cellContent]?.title)} className="dt-risk-rating-bullet"
                            style={{
                                backgroundColor: `${ResidualRisksRates[cellContent]?.color}`,
                                opacity: is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'owner_name',
            text: t('Risk owner'),
            sort: false,
            style: {
                width: '180px'
            },
            key: 8,
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'manager',
            text: t('Risk Manager'),
            sort: false,
            key: 9,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'tasks',
            text: t('Mitigation'),
            style: {
                maxWidth: '200px',
                wordWrap: 'break-word'
            },
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return cellContent && cellContent.length
                    ? cellContent.map((task, i) => {
                        const canRedirect = task.status?.toLowerCase() !== 'deleted'

                        return (
                            <Link 
                                to={canRedirect ? `/admin/risk-management/task/${task.id}/details?incomming_tab=all-risks` : '#'}
                                key={task.id}
                            >
                                {`T${task.secondary_id}`}
                                <span hidden={i === cellContent.length - 1}>
                                    ,{' '}
                                </span>
                            </Link>
                        )
                    })
                    : null
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 11,
            sort: true,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'is_deleted',
            text: t('Action'),
            headerStyle: {
                paddingInline: '30px',
                textAlign: 'center'
            },
            sort: false,
            key: 12,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center'>
                        {row.is_deleted ? (
                            <span className='text-danger'>
                                {t('DELETED')}
                            </span>
                        ) : (
                            <Button
                                onClick={() => onDeleteButtonClicked(row)}
                                outline
                                color='danger'
                                className='border-0'
                            >
                                <i className='ri-delete-bin-line font-size-24' />
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]
}

export const tableMitigationTasksColumnsRenderer = ({ t, dateUtils, history }) => {
    return [
        {
            dataField: 'secondary_id',
            text: t('Task ID'),
            style: {
                width: '5%'
            },
            key: 0,
            formatter: (cellContent, row) => {
                const canRedirect = row.status?.toLowerCase() !== 'deleted'

                return (
                    <span
                        style={{
                            cursor: canRedirect && 'pointer'
                        }}
                        className={canRedirect ? 'btn-link' : ''}
                        onClick={() =>
                            canRedirect &&
                            history.push(
                                `/admin/risk-management/task/${row.id}/details?incomming_tab=mitigation-tasks`
                            )
                        }
                    >
                        {`${row.supplier?.isOwnCompany ? 'E' : 'TP'}${row.supplier?.secondaryId}/R${row.relatedRisk.secondary_id}/T${row.secondary_id}`}
                    </span>
                )
            }
        },
        {
            dataField: 'name',
            text: t('Title'),
            style: {
                width: '10%'
            },
            key: 1,
            formatter: (cell, {
                id,
                is_recurring, 
                recurrence_secondary_id,
                status
            }) => {
                const canRedirect = status?.toLowerCase() !== 'deleted'

                return (
                    <div
                        className={canRedirect ? 'btn-link' : ''}
                        style={{ cursor: canRedirect ? 'pointer' : '' }}
                    >
                        {is_recurring && recurrence_secondary_id && (
                            <>
                                <i
                                    className="ri-repeat-2-line text-info me-1 font-size-18 align-middle"
                                    id={`recurring-task-${id}-tooltip`}
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                />
                                <UncontrolledTooltip
                                    placement="top"
                                    target={`recurring-task-${id}-tooltip`}
                                >
                                    {t('Recurring task')}
                                </UncontrolledTooltip>
                            </>
                        )}
                        {cell}{recurrence_secondary_id ? `-${recurrence_secondary_id}` : ''}
                    </div>
                )
            }
        },
        {
            dataField: 'relatedRisk',
            text: t('Related Risk'),
            sort: false,
            key: 2,
            formatter: (cellContent, row) => {
                const canRedirect = !row.relatedRisk.deleted

                return (
                    <span
                        style={{
                            cursor: canRedirect && 'pointer'
                        }}
                        onClick={() =>
                            canRedirect &&
                            history.push(
                                `/admin/risk-management/${row.relatedRisk.id}/details?incomming_tab=mitigation-tasks`
                            )
                        }
                    >
                        {formatRiskId({
                            organization: {
                                is_own_company: row.supplier?.isOwnCompany, 
                                secondary_id: row.supplier?.secondaryId
                            },
                            secondary_id: row.relatedRisk.secondary_id,
                            is_general: row.relatedRisk.is_general 
                        })}
                    </span>
                )
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 3,
            sort: true,
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'endedAt',
            text: t('Deadline'),
            key: 4,
            sort: true,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex flex-column justify-content-start align-items-baseline'>
                        {dateUtils.convertTimeStampToDate(
                            row.ended_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                        {row.ended_at && row.overdue && (
                            <span className='bg-danger me-1 badge badge-danger'>
                                {t('Overdue')}
                            </span>
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'manager',
            text: t('Task Manager'),
            sort: false,
            key: 5,
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'owner',
            text: t('Task Owner'),
            sort: false,
            key: 6,
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 7,
            style: {
                width: '10%'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row?.category?.name)}</div>
            }
        },
        {
            dataField: 'priority',
            text: t('Priority'),
            sort: false,
            key: 8,
            formatter: (cellContent, row) => {
                const taskPriority = TasksPriorities[row.priority]
                return (
                    <div className='d-flex justify-content-start'>
                        <span
                            style={{
                                color: `${taskPriority.color}`
                            }}
                        >
                            {taskPriority.icon}
                        </span>

                        <span style={{ marginLeft: '4px' }}>
                            {t(taskPriority.title)}
                        </span>
                    </div>
                )
            }
        },
        {
            dataField: 'status',
            text: t('Status'),
            sort: false,
            key: 9,
            formatter: (cellContent, row) => {
                const taskStatus = TasksStatuses[row.status]
                return (
                    <div
                        className='dt-task-status text-dark'
                        style={{
                            backgroundColor: `${taskStatus.color}`
                        }}
                    >
                        {t(taskStatus.title)}
                    </div>
                )
            }
        },
        {
            dataField: 'deleted_at',
            text: t('Deletion Date'),
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.deleted_at
                            ? dateUtils.convertTimeStampToDate(
                                  row.deleted_at,
                                  INTERNATIONAL_DATE_FORMAT
                              )
                            : null}
                    </div>
                )
            }
        }
    ]
}

export const tableMyRisksColumnsRenderer = ({
    t,
    dateUtils,
    onDeleteButtonClicked,
    history
}) => {
    return [
        {
            dataField: 'result_color',
            text: t('Rating'),
            headerStyle: {
                textAlign: 'center'
            },
            style: {
                width: '80px'
            },
            key: 1,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span
                            className='dt-risk-rating-bullet'
                            style={{
                                backgroundColor: `#${cellContent}`,
                                opacity: row.is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'id',
            text: t('Risk ID'),
            sort: false,
            style: {
                width: '80px'
            },
            key: 2,
            formatter: (cellContent, row) => {
                return (
                    <span
                        style={{
                            cursor: !row.is_deleted && 'pointer'
                        }}
                        className={!row.is_deleted ? 'btn-link' : ''}
                        onClick={() =>
                            !row.is_deleted &&
                            history.push(
                                `/admin/risk-management/${row.id}/details?incomming_tab=my-risks`
                            )
                        }
                    >
                        {formatRiskId(row)}
                    </span>
                )
            }
        },
        {
            dataField: 'title',
            text: t('Risk Title'),
            sort: false,
            key: 3,
            style: {
                width: '140px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {row.acceptance?.accepted && (
                            <div>
                                <span
                                    className='badge bg-success text-white rounded'
                                    style={{ cursor: "pointer" }}
                                    id={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('Accepted')}
                                </span>

                                <UncontrolledTooltip
                                    placement="top"
                                    target={`accepted-risk-${row.id}-badge`}
                                >
                                    {t('This risk has been accepted.')}<br />
                                    {t('Justification')}: {row.acceptance?.reason}
                                </UncontrolledTooltip>
                            </div>
                        )}
                        <span
                            style={{
                                cursor: !row.is_deleted && 'pointer'
                            }}
                            onClick={() =>
                                !row.is_deleted &&
                                history.push(
                                    `/admin/risk-management/${row.id}/details?incomming_tab=my-risks`
                                )
                            }
                            className={!row.is_deleted ? 'btn-link' : ''}
                        >{cellContent}</span>
                    </div>
                )
            }
        },
        {
            dataField: 'case_id',
            text: t('Entity'),
            headerStyle: {
                textAlign: 'center'
            },
            sort: false,
            key: 4,
            style: {
                width: '100px'
            },
            formatter: (cellContent, row) => {
                return (
                    <div className='text-center'>
                        {row.organization.name}
                    </div>
                )
            }
        },
        {
            dataField: 'category',
            text: t('Category'),
            sort: false,
            key: 5,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row.category.main.name)}</div>
            }
        },
        {
            dataField: 'category',
            text: t('Sub Category'),
            sort: false,
            key: 6,
            style: {
                width: '120px'
            },
            formatter: (cellContent, row) => {
                return <div>{t(row.category.subCategory.name)}</div>
            }
        },
        {
            dataField: "residual_risk",
            text: t("Residual Risk Rate"),
            sort: false,
            key: 7,
            style: {
                width: '120px'
            },
            formatter: (cellContent, {
                is_deleted
            }) => {
                return (
                    <div>
                        <span title={t(ResidualRisksRates[cellContent]?.title)} className="dt-risk-rating-bullet"
                            style={{
                                backgroundColor: `${ResidualRisksRates[cellContent]?.color}`,
                                opacity: is_deleted ? 0.15 : 1
                            }}
                        />
                    </div>
                )
            }
        },
        {
            dataField: 'owner_name',
            text: t('Risk owner'),
            sort: false,
            key: 8,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'manager',
            text: t('Risk Manager'),
            sort: false,
            key: 9,
            style: {
                width: '180px'
            },
            formatter: (cellContent, row) => {
                return cellContent ? (
                    <div className='d-flex  justify-content-center align-items-center'>
                        <span className='dt-list-col-bullet'>
                            {cellContent[0]}
                        </span>{' '}
                        <span className='dt-list-col-bullet-text'>
                            {cellContent}
                        </span>
                    </div>
                ) : null
            }
        },
        {
            dataField: 'tasks',
            text: t('Mitigation'),
            style: {
                maxWidth: '200px',
                wordWrap: 'break-word'
            },
            sort: false,
            key: 10,
            formatter: (cellContent, row) => {
                return cellContent && cellContent.length
                    ? cellContent.map((task, i) => {
                        const canRedirect = task.status?.toLowerCase() !== 'deleted'

                        return (
                            <Link 
                                to={canRedirect ? `/admin/risk-management/task/${task.id}/details?incomming_tab=my-risks` : '#'}
                                key={task.id}
                            >
                                {`T${task.secondary_id}`}
                                <span hidden={i === cellContent.length - 1}>
                                    ,{' '}
                                </span>
                            </Link>
                        )
                    })
                    : null
            }
        },
        {
            dataField: 'createdAt',
            text: t('Creation Date'),
            key: 11,
            style: {
                width: '120px'
            },
            sort: true,
            formatter: (cellContent, row) => {
                return (
                    <div>
                        {dateUtils.convertTimeStampToDate(
                            row.created_at,
                            INTERNATIONAL_DATE_FORMAT
                        )}
                    </div>
                )
            }
        },
        {
            dataField: 'is_deleted',
            text: t('Action'),
            headerStyle: {
                paddingInline: '30px',
                textAlign: 'center'
            },
            sort: false,
            key: 12,
            formatter: (cellContent, row) => {
                return (
                    <div className='d-flex justify-content-center'>
                        {row.is_deleted ? (
                            <span className='text-danger'>
                                {t('DELETED')}
                            </span>
                        ) : (
                            <Button
                                onClick={() => onDeleteButtonClicked(row)}
                                outline
                                color='danger'
                                className='border-0'
                            >
                                <i className='ri-delete-bin-line font-size-24' />
                            </Button>
                        )}
                    </div>
                )
            }
        }
    ]
}

export const riskIdGenerator = ({ risk }) => {
    const supplierId = risk?.organization?.secondaryId || risk?.supplierId

    if (!supplierId) return `R${risk?.secondaryId}` // general risk

    return `${risk?.organization?.isOwnCompany ? 'E' : 'TP'}${supplierId}/R${risk?.secondaryId}`
}

export const riskDetailPageHeaderText = ({ risk }) => {
    const supplierId = risk?.organization?.secondaryId || risk?.supplierId

    return `${risk?.organization?.isOwnCompany ? 'E' : 'TP'}${supplierId}/R${risk?.secondary_id}`
}

export const taskDetailPageHeaderText = ({ task }) => {
    return `${task?.organization?.isOwnCompany ? 'E' : 'TP'}${task?.organization?.secondaryId || task?.supplier}/R${
        task?.relatedRisk?.secondary_id
    }/T${task?.secondary_id}`
}

export const taskIdGenerator = ({ task }) => {
    return `${task?.organization?.isOwnCompany ? 'E' : 'TP'}${task?.organization?.secondaryId || task?.supplier}/R${
        task?.relatedRisk?.secondary_id
    }/T${task?.secondary_id}`
}